import _ from 'lodash';
import { Component, Input, OnInit } from '@angular/core';
import { FrequencyUnit, Product } from '../../../../../../../common/js/static/Product';
import { SafeInviteInfo } from '../../../../../../../common/js/customer/SafeInviteInfo';
import { SafeWholePolicy } from '../../../../../../../common/js/customer/SafePolicyInfo';
import { Exchange1035FundingPurpose } from '../../../../../../../coverpath-common/js/interfaces/CoverpathTypes';

@Component({
  moduleId: module.id,
  selector: 'client-cost-breakdown',
  templateUrl: './client-cost-breakdown.component.html',
})
export class ClientCostBreakdown implements OnInit {
  // shared values
  totalPremium: number;
  artDescription: string;

  // term values
  hasTermPolicy: boolean = false;
  termPremium: number;
  termHasECP: boolean;
  termHasWOP: boolean;
  termWOPValue: number;
  termBasePremium: number;

  // whole values
  hasWholeLifePolicy: boolean = false;
  wholePremium: number;
  wholeHasWOP: boolean;
  wholeWOPValue: number;
  wholeTerm: string;
  hasGir: boolean = false;
  hasRtr: boolean = false;
  hasAlir: boolean = false;
  hasCir: boolean = false;
  hasExchange1035: boolean = false;
  hasExchange1035TowardsPremium: boolean = false;
  girPremium: number;
  rtrPremium: number;
  alirPremium: number;
  cirPremium: number;
  exchange1035Premium: number = 0;
  wholeBasePremium: number;

  // Quote properties
  term: string;
  frequencyUnit: string;
  isART: boolean;

  @Input() safeInviteInfo: SafeInviteInfo;

  ngOnInit() {
    this.hasTermPolicy = this.safeInviteInfo.safePolicyInfo.hasTerm;
    this.hasWholeLifePolicy = this.safeInviteInfo.safePolicyInfo.hasWhole;

    if (this.hasTermPolicy) {
      const termPolicy = this.safeInviteInfo.safePolicyInfo.termInfo;
      this.termBasePremium = termPolicy.base;
      this.termHasWOP = termPolicy.hasWOP;
      this.termHasECP = termPolicy.hasECP;
      this.termWOPValue = termPolicy.WOPValue;
      this.term = termPolicy.term.toString();
      this.isART = termPolicy.isART;
      this.artDescription = Product.products.CASTerm.artDescription;
      this.termPremium = termPolicy.totalPremium;
    }

    if (this.hasWholeLifePolicy) {
      const wholeLifePolicy = this.safeInviteInfo.safePolicyInfo.wholeInfo;
      this.wholePremium = wholeLifePolicy.totalPremium;
      this.wholeHasWOP = wholeLifePolicy.hasWOP;
      this.wholeWOPValue = wholeLifePolicy.WOPValue;
      this.wholeTerm = wholeLifePolicy.term.toString();

      this.hasGir = wholeLifePolicy.hasGIR;
      this.girPremium = this.hasGir ? wholeLifePolicy.gir.premium : 0;

      this.hasRtr = wholeLifePolicy.hasRTR;
      this.rtrPremium = this.hasRtr ? wholeLifePolicy.rtr.premium : 0;

      this.hasCir = wholeLifePolicy.hasCIR;
      this.cirPremium = this.hasCir ? wholeLifePolicy.cir.premium : 0;

      this.wholeBasePremium = wholeLifePolicy.basePremium;

      this.hasAlir = wholeLifePolicy.hasALIR;
      this.alirPremium = this.hasAlir ? wholeLifePolicy.alir.premium : 0;
      this.hasExchange1035 = wholeLifePolicy.hasExchange1035;

      if (
        wholeLifePolicy.hasExchange1035 &&
        wholeLifePolicy.exchange1035.applyTowards === Exchange1035FundingPurpose.PREMIUM_AND_ALIR
      ) {
        this.hasExchange1035TowardsPremium = wholeLifePolicy.hasExchange1035;
        this.exchange1035Premium =
          wholeLifePolicy.exchange1035.cashValueTransfer < this.wholePremium
            ? wholeLifePolicy.exchange1035.cashValueTransfer
            : this.wholePremium;
        this.exchange1035Premium = -1 * this.exchange1035Premium;
      }
    }

    this.frequencyUnit = FrequencyUnit[_.startCase(this.safeInviteInfo.safePolicyInfo.paymentFrequency)];
    this.totalPremium = this.safeInviteInfo.safePolicyInfo.totalPremiumAmount;
  }

  // Don't show breakdown if it only has the base premium
  isShown(): boolean {
    const isJointApp = this.safeInviteInfo.isJointApp;
    const hasTermAddOns = this.termHasECP || this.termHasWOP;
    const hasWholeLifeAddOns =
      this.hasWholeLifePolicy &&
      (this.wholeHasWOP ||
        this.hasExchange1035TowardsPremium ||
        this.hasRiders(this.safeInviteInfo.safePolicyInfo.wholeInfo));
    return isJointApp || hasTermAddOns || hasWholeLifeAddOns;
  }

  hasRiders(wholeLifePolicy: SafeWholePolicy): boolean {
    if (wholeLifePolicy.hasGIR || wholeLifePolicy.hasRTR || wholeLifePolicy.hasALIR || wholeLifePolicy.hasCIR) {
      return true;
    }

    return false;
  }
}
